<template>
    <div class="cigo-edit">
        <div class="title-area"></div>
        <div class="content-layer">
            <div class="select-file">
                <cigo-icon-font class="file-icon" :name="'cigoadmin-icon-xls'"></cigo-icon-font>
                <div class="info">
                    <span class="title">{{layerData.title ? layerData.title : '导入Excel数据'}}</span>
                    <span class="summary">文件后缀必须为xls或者xlsx（即为Excel文件），文件大小不得超过20M，最多支持导入10000条数据</span>
                    <input
                        type="file"
                        ref="vFileRef"
                        style="display:none;width:0;height:0;padding:0;"
                        @change="fileSelectChange($event.target.files)"
                        accept="xls, xlsx"
                    />
                    <a-button type="primary" @click.stop="chooseFile">选择文件</a-button>
                </div>
            </div>

            <a-table
                class="data-list"
                :rowKey="'__rowNum__'"
                :locale="{emptyText:'表格无数据'}"
                :columns="columns"
                :data-source="dataListRef"
                :pagination="true"
                :scroll="tableScroll"
            >
                <template v-slot:operation="{ record }">
                    <a-button
                        class="opt-btn"
                        @click.stop="removeRow(record)"
                        type="danger"
                        shape="circle"
                        size="small"
                        title="移除"
                    >
                        <template v-slot:icon>
                            <cigo-icon-font
                                :name="'cigoadmin-icon-shanchu1'"
                                class="opt-icon opt-primary opt-del"
                            ></cigo-icon-font>
                        </template>
                    </a-button>
                </template>
            </a-table>
        </div>
        <div class="btn-area">
            <a-button-group>
                <a-button type="primary" @click.stop="doSubmit">导 入</a-button>
                <a-button type="default" @click.stop="cancel">取 消</a-button>
            </a-button-group>
        </div>
    </div>
</template>

<script lang="ts">
import {
    computed,
    defineComponent,
    onBeforeMount,
    reactive,
    ref,
    toRaw,
    watch
} from "vue";
import XLSX from "xlsx";
import { apiErrorCatch, apiRequest, apiSign } from "@/common/http";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import cigoLayer from "@/components/cigo-layer";

export default defineComponent({
    name: "ImportExcelData",
    components: {
        CigoIconFont
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let xlsxObj = null;
        const doSubmit = () => {
            new Promise((resolve, reject) => {
                ctx.emit(
                    "notify",
                    "ok",
                    toRaw(dataListRef.value),
                    resolve,
                    reject
                );
            })
                .then(() => {
                    ctx.emit("close");
                })
                .catch(() => {
                    console.log("hold on");
                });
        };

        const cancel = () => {
            ctx.emit("close");
        };

        /*************************************************/
        const tableScroll = Object.assign(
            {
                x: 1500,
                y: "max-content"
            },
            props.layerData.tableScroll ? props.layerData.tableScroll : {}
        );
        const columns = computed(() => {
            let middleColumns: any[] = [];

            if (props.layerData.customColumns && props.layerData.columns) {
                middleColumns = [...props.layerData.columns];
            } else {
                if (dataListRef.value.length > 0) {
                    let colKeys = Object.keys(dataListRef.value[0]);
                    colKeys.every((key, index, arr) => {
                        middleColumns.push(
                            Object.assign(
                                index < arr.length - 1
                                    ? { width: "150px" }
                                    : {},
                                {
                                    title:
                                        props.layerData.columnsNameMap &&
                                        props.layerData.columnsNameMap.has(key)
                                            ? props.layerData.columnsNameMap.get(
                                                  key
                                              )
                                            : key,
                                    dataIndex: key
                                }
                            )
                        );
                        return true;
                    });
                }
            }

            return [
                {
                    title: "序号",
                    dataIndex: "__rowNum__",
                    width: "80px"
                },
                ...middleColumns,
                {
                    title: "操作",
                    key: "operation",
                    fixed: "right",
                    width: 80,
                    slots: {
                        customRender: "operation"
                    }
                }
            ];
        });
        let dataListRef: any = ref([]);
        const removeRow = (record: any) => {
            cigoLayer.confirm({
                layerData: {
                    msg: "确定删除吗？",
                    showCancel: true
                },
                ok: () => {
                    let tmpList = [...dataListRef.value];
                    tmpList.splice(tmpList.indexOf(record), 1);
                    dataListRef.value = [...tmpList];
                }
            });
        };
        /*************************************************/

        let vFileRef: any = ref(null);
        let selectedFileRef: any = ref(null);
        let xlsxFileData: any = ref([]);
        watch(xlsxFileData, (newVal: any) => {
            if (newVal.length && newVal[0].sheet) {
                dataListRef.value = [...newVal[0].sheet];
            } else {
                dataListRef.value = [];
            }

            console.log("sheetData:", dataListRef.value);
        });
        const chooseFile = () => {
            vFileRef.value.click();
        };
        const fileSelectChange = (fileList: any[]) => {
            if (!fileList || fileList.length == 0) {
                return;
            }
            selectedFileRef.value = fileList[0];
            checkFile()
                .then(() => {
                    return readFileData();
                })
                .then((sheetData: any) => {
                    xlsxFileData.value = [...sheetData];
                });
        };
        /*************************************************/
        const readFileData = () => {
            return new Promise((resolve, reject) => {
                var fileReader = new FileReader();
                fileReader.onload = event => {
                    if (!event.target) {
                        return;
                    }
                    var fileData = event.target.result;
                    xlsxObj = XLSX.read(fileData, {
                        type: "binary"
                    });
                    console.log("xlsxObj:", xlsxObj);

                    if (xlsxObj.SheetNames.length == 0) {
                        cigoLayer.msg("Excel没有sheet？");
                        return;
                    }
                    resolve([
                        {
                            sheetName: xlsxObj.SheetNames[0],
                            sheet: XLSX.utils.sheet_to_json(
                                xlsxObj.Sheets[xlsxObj.SheetNames[0]]
                            )
                        }
                    ]);
                };
                fileReader.readAsBinaryString(toRaw(selectedFileRef.value));
            });
        };
        const checkFile = () => {
            return new Promise((resolve, reject) => {
                if (!window.FileReader) {
                    cigoLayer.msg("不支持读取本地File");
                    return;
                }
                const suffix = selectedFileRef.value.name.split(".")[1];
                const fileType = ["xlsx", "xls", "csv"].some(
                    item => item === suffix
                );
                if (!fileType) {
                    cigoLayer.msg("请上传xls,xlsx,csv格式的文件");
                    return;
                } else {
                    resolve();
                }
            });
        };

        /*************************************************/

        return {
            tableScroll,
            columns,

            dataListRef,
            vFileRef,
            chooseFile,
            fileSelectChange,
            removeRow,

            doSubmit,
            cancel
        };
    }
});
</script>

<style lang="scss">
.cigo-edit {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .title-area {
        background-color: #f5f5f5;
        border-bottom: 1px solid #f0f0f0;
        padding: 15px 12px;
        display: flex;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        flex-direction: row;
        justify-content: center;
        font-size: 16px;
    }

    .content-layer {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
        overflow-x: hidden;
        overflow-y: scroll;
        padding: 10px;

        .select-file {
            border: 1px solid #f0f0f0;
            padding: 15px;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-radius: 5px;

            .file-icon {
                width: 130px;
                height: 130px;
                padding: 15px;
                border: 1px solid #f0f0f0;
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
                background-color: #f5f5f5;
            }

            .info {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                border: 1px solid #f0f0f0;
                border-left: 0px;
                height: 130px;
                padding-left: 15px;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;

                .title {
                    font-size: 18px;
                    font-weight: 700;
                    color: #666;
                    margin-bottom: 5px;
                }

                .summary {
                    font-size: 13px;
                    font-weight: 500;
                    color: #aaa;
                    margin-bottom: 10px;
                }
            }
        }
    }

    .btn-area {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding: 8px 12px;
        border-top: 1px solid #f0f0f0;
    }
}
</style>
